import { gql } from '@apollo/client/core/index.js'

export const queries = {
  GET_CAMPAIGN_GROUP_CONFIGURATION: gql`
    query SELECT_GetCampaignGroupConfiguration($campaign_group_id: Int!) {
      getCampaignGroupById(campaign_group_id: $campaign_group_id) {
        campaign_group_id
        advertiser_id
        status
        delivery_mode_id
        product_id
        is_test
        experiment_cloned_from {
          campaign_group_id
        }
      }
      getAudienceByCampaignGroupId(campaign_group_id: $campaign_group_id) {
        audience_id
      }
    }
  `,
  GET_CAMPAIGN_GROUP_BY_ID: gql`
    query SELECT_GetCampaignGroupById($campaign_group_id: Int!) {
      getCampaignGroupById(campaign_group_id: $campaign_group_id) {
        campaign_group_id
        advertiser_id
        name
        is_test
        campaigns {
          campaign_template_type
        }
        spend
        start_time
        end_time
        status
        goal_type
        available_actions
        budget_summary {
          effective_budget
          ineffective_budget
          total_budget
        }
        ui_creatives_status {
          status
          details
          error
          warning
          action
        }
        ref_id
        ref_type
      }
    }
  `,
  GET_CAMPAIGN_GROUPS: gql`
      query SELECT_GetCampaignGroups($page: Int, $limit: Int, $sort_by: String, $sort_order: SortEnum, $filter: CampaignGroupFilterInput) {
        getCampaignGroups(page: $page, limit: $limit, sort_by: $sort_by, sort_order: $sort_order, filter: $filter) {
        count
        rows {
        campaign_group_id
        name
        is_test
        start_time
        end_time
        status
        available_actions
        budget_summary {
          effective_budget
          ineffective_budget
          total_budget
        }
        ref_id
        ref_type
      }
    }
  }
  `,
  GET_ACCESSIBLE_CAMPAIGN_GROUP_IDS: gql`
    query SELECT_GetAccessibleCampaignGroupIds($page: Int, $limit: Int, $filter: CampaignGroupFilterInput) {
      getCampaignGroups(page: $page, limit: $limit, filter: $filter) {
        count
        rows {
          campaign_group_id
        }
      }
    }
  `,
  GET_CAMPAIGN_GROUPS_BY_EXTERNAL_REF_IDS: gql`
query SELECT_GetCampaignGroupsByExternalRefIds($ref_ids: [Int!]!, $ref_type: CampaignGroupRefTypeEnum!, $filter: CampaignGroupFilterInput, $page: Int, $limit: Int, $sort_by: String, $sort_order: SortEnum, $propagateReportingErrors: Boolean = false) {
  getCampaignGroupsByExternalRefIds(ref_ids: $ref_ids, ref_type: $ref_type, filter: $filter, page: $page, limit: $limit, sort_by: $sort_by, sort_order: $sort_order, propagateReportingErrors: $propagateReportingErrors) {
    count
    rows {
      campaign_group_id
      advertiser_id
      name
      spend
      start_time
      end_time
      status
      goal_type
      available_actions
      budget_summary {
          effective_budget
          allocatable_effective_budget
          ineffective_budget
          total_budget
        }
      ui_creatives_status {
        status
        details
        error
        warning
        action
      }
      ref_id
      ref_type
      is_test
    }
  }
}
`,
  GET_CAMPAIGN_GROUPS_BY_PRIVATE_MARKETPLACE_GROUP_ID: gql`
query SELECT_GetCampaignGroupsByPrivateMarketplaceGroupId($private_marketplace_group_id: Int!) {
  getCampaignGroupsByPrivateMarketplaceGroupId(private_marketplace_group_id: $private_marketplace_group_id) {
    campaign_group_id
    advertiser_id
    name
    spend
    start_time
    end_time
    status
    goal_type
    available_actions
    budget_summary {
      effective_budget
      ineffective_budget
      total_budget
    }
    ui_creatives_status {
      status
      details
      error
      warning
      action
    }
    ref_id
    ref_type
    is_test
  }
}
`,
}

export const mutations = {
  CREATE_CAMPAIGN_GROUP: gql`
    mutation SELECT_CreateCampaignGroup(
      $advertiser_id: Int!
      $objective_type: ObjectiveTypeEnum!
      $update: CampaignGroupUpdateInput!
    ) {
      createCampaignGroup(
        advertiser_id: $advertiser_id
        objective_type: $objective_type
        update: $update
      ) {
        campaign_group_id
        product_id
      }
    }
  `,
  CLONE_CAMPAIGN_GROUP_EXPERIMENT: gql`
    mutation SELECT_CloneCampaignGroupExperiment(
      $campaign_group_id: Int!
      $update: CampaignGroupUpdateInput!
    ) {
      cloneCampaignGroupById(
        campaign_group_id: $campaign_group_id
        update: $update
        is_experiment: true
      ) {
        campaign_group_id
        product_id
      }
    }
  `,
}
